import { createContext, useContext, useEffect, useState } from "react";
import { ALL_KEY } from "../../../components/CustomRadioButton/enumerations/enumerations";
import { useGetCoaches } from "../../../hooks/Coach/coach.hooks";
import { CoachResponse } from "../../../hooks/Coach/data";
import { CoachesContextProviderType, CoachesContextType } from "../data";

const CoachesContext = createContext<CoachesContextType>({
  value: ALL_KEY,
  setValue: (value: string) => {},
  selectedResort: ALL_KEY,
  setSelectedResort: (value: string) => {},
  filterCoachList: [],
});

export const CoachesContextProvider = ({
  children,
}: CoachesContextProviderType) => {
  const [value, setValue] = useState(ALL_KEY);
  const [selectedResort, setSelectedResort] = useState(ALL_KEY);
  const [filterCoachList, setFilterCoachList] = useState<CoachResponse[]>([]);

  const { data: coachList } = useGetCoaches({}, {});

  useEffect(() => {
    if (!coachList) return;

    setFilterCoachList(
      coachList.filter((coach: CoachResponse) => {
        const matchSkill = value === ALL_KEY || coach.skill_codes.includes(value);
        const matchResort =
          selectedResort === ALL_KEY ||
          coach.ski_resort_codes.includes(selectedResort);
        return matchSkill && matchResort;
      })
    );
  }, [coachList, value, selectedResort]);
  return (
    <CoachesContext.Provider
      value={{
        value,
        setValue,
        selectedResort,
        setSelectedResort,
        filterCoachList,
      }}
    >
      {children}
    </CoachesContext.Provider>
  );
};

export const useCoachesContext = () => {
  const Value = useContext(CoachesContext);
  return Value;
};
